import type { CustomFormFieldsParams } from './customFields.interface';

// One factory so every reader and every invalidation spell the keys the same way.
export const customFieldsKeys = {
  all: ['custom-fields'] as const,
  lists: () => [...customFieldsKeys.all, 'list'] as const,
  list: (subjectType: string = 'requisition') =>
    [...customFieldsKeys.lists(), subjectType] as const,
  formFieldsAll: () => [...customFieldsKeys.all, 'form-fields'] as const,
  formFields: (params: CustomFormFieldsParams) =>
    [...customFieldsKeys.formFieldsAll(), params] as const,
};
